// @core/api/endpoints/subscription/get_subscription_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SubscriptionItemResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get subscription item
 * Retrieves details of a specific subscription line item.
 */
export async function GetSubscriptionItem(
  subscription_id: string,
  item_id: string,
  options?: RequestOptions
): Promise<SubscriptionItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/items/:item_id`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.get<SubscriptionItemResponse>(requestPath, { ...requestOptions });
}
